import { FormsModule } from '@angular/forms';
import { SubmitdataService } from './../../services/submitdata/submitdata.service';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnChanges } from '@angular/core';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { ConstantsModule } from './../../common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as L from 'leaflet';
import { MapconstantsModule } from '../geoportal/gis/mapconstants/mapconstants.module';
import { BreadcrumbComponent } from 'src/app/common/breadcrumb/breadcrumb.component';
import { GisService } from 'src/app/services/gis/gis.service';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { isNullOrUndefined } from 'util';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { send } from 'q';
import { TranslateService } from '@ngx-translate/core';
//import { indicatorlist} from '/home/vassar/iwm/ui/NMCFrontEnd/src/assets/i18n/hi.json'
import { DatasubmitapprovalsComponent } from '../submitdata/datasubmitapprovals/datasubmitapprovals.component';
import { districtsdata ,chartDatas , indicatorlist} from 'src/assets/i18n/hi.json'

@Component({
  selector: 'app-mis',
  templateUrl: './mis.component.html',
  styleUrls: ['./mis.component.css']
})
export class MisComponent implements OnInit {
  // @Output() activeTab = new EventEmitter<Object>();
  // @Input() activeTab:any;
  lang;
  map: L.Map;
  showmap: boolean;
  smartchartview: any;
  indicatormap;
  statelayer;
  htmlLegend;
  bubblechartdata;
  customdata = {};
  showcustomtable: boolean;
  @Input() selectedYear;
  nonhimalayanchartdata: any;
  himalayanchartdata: object = {};
  unionchartdata: any;
  chartData = {};
  smartchartdata = {};
  statelist = [];
  group_array = [];
  rankactual = [];
  urlparams = {};
  tabledata: any;
  showchart: boolean;
  showtabledata: boolean;
  showindicatordata: boolean;
  stateLevel: boolean = true;
  showthemedata: boolean;
  prevyear: any;
  curyear: any;
  idField = [];
  activeSpinner: boolean;
  customTableData = [];
  nonhimalayanFYchartdata = {};
  noneasternFYchartdata = {};
  unionFYchartdata = {};
  indicatordata = {};
  themedata = {};
  type: string;
  uuid: any;
  selectedDistName:any;
  activesidetab: string = 'smartchart';
  
  nonhimalayanstateArray: any = [];
  noneasternstateArray: any = [];
  unionstateArray: any = [];
  nonhimalayanFYstateArray: any = [];
  noneasternFYstateArray: any = [];
  unionFYstateArray: any = [];
  indicatorArray: any = [];
  themearray: any = [];
  tab = 0;
  group: any;
  customlabels = {};
  statelevel: any;
  urlParams: object;
  dataVariable: any[];
  dropdownlist: any[];
  Statedropdownlist: any;
  dropdownstate: any;
  activespineer: boolean = false;
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  state_nodal_officer: string;
  userdetails: any;
  currentGroupState = ["NON HIMALAYAN"];
  Statespecified: any;
  stateSpecified: string;
  districtslu: any;
  monthlist: any;
  statearrayList: any;
  biharchartData: any;
  biharstateArray: any[];
  stateitemList: any = []
  jkchartdata: {};
  jharkandstateArray: any[];
  UPchartdata: any;
  UPstateArray: any[];
  UKchartdata: any;
  UKstateArray: any[];
  WBchartdata: any;
  WBstateArray: any[];
  locationData = {};
  locationBiharData: {};
  locationBiharStateArray: any[];
  locationJKData: { "title": string; "baseyear": any; "curyear": any; "seriesdata": ({ type: string; name: string; data: any[]; yAxis?: undefined; } | { yAxis: number; type: string; name: string; data: any[]; })[]; };
  locationJKStateArray: any[];
  locationUPData: { "title": string; "baseyear": any; "curyear": any; "seriesdata": ({ type: string; name: string; data: any[]; yAxis?: undefined; } | { yAxis: number; type: string; name: string; data: any[]; })[]; };
  locationUPStateArray: any[];
  locationUKData: { "title": string; "baseyear": any; "curyear": any; "seriesdata": ({ type: string; name: string; data: any[]; yAxis?: undefined; } | { yAxis: number; type: string; name: string; data: any[]; })[]; };
  locationUKStateArray: any[];
  locationWBData: { "title": string; "baseyear": any; "curyear": any; "seriesdata": ({ type: string; name: string; data: any[]; yAxis?: undefined; } | { yAxis: number; type: string; name: string; data: any[]; })[]; };
  locationWBStateArray: any[];
  indicatorMetadata: any;
  showindchartdata: boolean;
  showthemechartdata: boolean;
  showbooleanmap: boolean;
  indicatormetadataArray: any[];
  indicatorChart = {};
  filterstates: any;
  themeList: any[];
  themechartdata: {};
  getcomapriondata: any = [];
  showcomparisondata: boolean;
  filterdist: any;
  basestateId: any;
  basedistrictId: any;
  tabledataobject: any = [];

  activeLayers = {};
  monthsList:any;

  constructor(private constants: ConstantsModule,
    private utils: UtilsModule,
    private router: Router,
    private translate: TranslateService,
    private submitdataSerivce: SubmitdataService,
    private logsrv: AuthloginService,
    private mapConstantsModule: MapconstantsModule,
    private gisService: GisService,
    private route: ActivatedRoute,
  ) {
    translate.setDefaultLang('en');
  }

  getPrev() {
    this.tab = this.tab === 0 ? 0 : this.tab - 1;
  }

  getNext() {
    this.tab = this.tab === this.group_array.length ? this.tab : this.tab + 1;
  }
  activeFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null
  };
  changeLabel(value) {
    this.statelevel = value;
  }
  changeMonth(month) {
    this.monthlist = month;    
  }
  changeUUID(uuid) {
    this.filterstates = uuid;
  }
  changeDistuuid(dist) {
    this.filterdist = dist;
  }
  baseState(e) {
    this.basestateId = e;
  }
  basedistrict(event) {   
    this.basedistrictId = event;
  }
  getLanguage(event) {

    this.lang=event;
    this.handleEventFromFilter(event); 
    // this.items.push(newItem);
  }
  getDistrictName(event){
    // console.log('event in mis',event);
    this.selectedDistName=event;

  }

  handleEventFromFilter(value) {
    this.urlparams = {};
    this.urlparams = value;
    this.group = value.grouparray;
    //this.statearrayList = value.data;
    this.statearrayList=value.statelists;
    this.selectedYear = value.assesmentyear;
    this.tab = 0;

    if (this.activesidetab == 'indicatorchart') {
      this.type = 'INDICATOR'
      this.uuid = value.indicatorarray
    }
    if (this.activesidetab == 'themechart') {
      this.type = 'THEME'
      this.uuid = value.themearray
    }

    this.group_array = [];

    if (this.activesidetab != "customranking") {
      Object.keys(this.group).forEach(key => {
        this.group_array.push(this.group[key]['item_text']);
      })
    }    
    if (this.activesidetab == "smartchart"){
      let locationlist=[];
      this.stateitemList=[];
    Object.keys(this.statearrayList).forEach(key => {
      this.stateitemList.push(this.statearrayList[key]['item_text']);
      // this.stateitemList=this.statearrayList[key]['item_text'];
    })
    Object.keys(this.statearrayList).forEach(statelist => {
        locationlist.push(this.statearrayList[statelist]['item_id']);
      });
    }    
  
    this.curyear = this.getDateFormat(this.selectedYear, true);
    this.prevyear = this.getDateFormat(this.selectedYear, false);
    if (this.activesidetab == 'smartchart') {
      this.getsmartChartViewData();
      this.getlocationcomparisionData();
    }
    else if (this.activesidetab == "comparison") {
      this.gettabledata();
      // this.downloadExcel();
    }
    else if (this.activesidetab == "customranking") {
      this.getCustomTableData();
    }
    // else if(this.activesidetab=='indicatorchart' || this.activesidetab == 'themechart'){
    //   this.getindicatorwiseCompare();
    // }
    else
      this.getindicatorwiseCompare();

    if (this.activesidetab == 'indicatorstatus') {
      this.getTableData();
    }
    
    if (this.userdetails && this.userdetails['roles'][0] == 'VALIDATION_AGENCY') {
      this.activesidetab == 'indicatorstatus';
    } else {
      this.activesidetab == 'smartchart';
    }

  }

  getDateFormat(date: string, flag: boolean) {
    let d = date.split('-');
    let x = +d[0].slice(2) - 1;
    let y = +d[1].slice(2) - 1;
    if (flag == true)
      return d[0].slice(2) + '-' + d[1].slice(2);
    else
      return x.toString() + '-' + y.toString();
  }

  async ngOnInit() {
    //this.monthlist=this.setCurrentMonthDefault();
    
    let dropdownYear;
    //  = this.submitdataSerivce.getassesmentYear();
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      dropdownYear = data['data'];
    })
    this.state_nodal_officer = this.constants.USER_TYPES["VALIDATION_AGENCY"];
    this.userdetails = this.logsrv.checkloginstatus();

    this.group = [{ item_id: "20d5931b-d962-4b4f-9fde-08d9db3db3e8", item_text: "NON HIMALAYAN" }];
    this.selectedYear = dropdownYear[dropdownYear.length - 1];
    this.tab = 0;

    this.curyear = this.getDateFormat(this.selectedYear, true);
    this.prevyear = this.getDateFormat(this.selectedYear, false);

    this.group_array = [];

    Object.keys(this.group).forEach(key => {
      this.group_array.push(this.group[key]['item_text']);
    })

    if (this.activesidetab == 'smartchart') {
      this.getDataForBarChart();
      this.getlocationcomparisionData();
    } else {
      this.group = "20d5931b-d962-4b4f-9fde-08d9db3db3e8";

      this.getComparisonTableData();
    }
    // this.urlParams = this.utils.getWritableObject(this.route.snapshot.params);
    // this.breadCrumb.update(this.router.url);
    if (this.activesidetab == 'indicatorstatus') {
      this.getTableData();
    }
    


  }

  // setCurrentMonthDefault(){
  //   let currentmonth = new Date().getMonth()
  //   let currentmonthObj;
  //   this.monthsList.forEach(monthObj =>{
  //     if(parseInt(monthObj['key'])  == currentmonth + 1){
  //       currentmonthObj = monthObj;
  //     }
  //   });
  //   this.monthlist['montharray'] = currentmonthObj['key'];
  //   return this.monthlist;

  // }
  

  initializeMap(data): void {
    this.addMap();
    this.createPanes();
    this.addHTMLLegend();
    this.revalidateMap();
    this.createLayer(data);
  }
  revalidateMap(): void {
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200)
    }

  }
  addHTMLLegend() {
    // new L.Control.HtmlLegend(options)
    let legend = (L as any).control.htmllegend({
      position: 'bottomright',
      collapseSimple: true,
      detectStretched: true,
      collapsedOnInit: false,
    });
    this.map.addControl(legend);
    // legend.addTo(this.map);
    this.htmlLegend = legend;
  }
  getTableData() {
    this.stateLevel = true;
    this.dropdownlist = [];
    let itemid: any = [];
    Object.keys(this.group).forEach(key => {
      itemid.push(this.group[key]['item_id']);
    })
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['STATE'],
      "pType": this.constants.LOCATION_CONSTANT['REGION'],
      "ay": this.selectedYear,
      "view": "admin",
      "locations": "[" + itemid.toString() + "]"

    }
    this.submitdataSerivce.userStatus(postdata).subscribe(data => {
      Object.keys(data).forEach(skey => {
        Object.keys(data[skey]).forEach(dKey => {
          this.dropdownlist.push(data[skey][dKey]);
          this.dropdownlist.sort((a, b) => (a.name > b.name) ? 1 : -1);
        });
      });
    });

  }

  onClick(name, uuid) {
    if (this.selectedYear == '2019-2020') {
      this.stateLevel = false;
      let itemid = [];
      itemid.push(uuid);
      this.districtslu = uuid;
      let postdata = {
        "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
        "pType": this.constants.LOCATION_CONSTANT['STATE'],
        "ay": this.selectedYear,
        "view": "admin",
        "locations": "[" + itemid.toString() + "]"

      }
      this.activeSpinner = true;
      this.submitdataSerivce.userStatus(postdata).subscribe(data => {
        this.activeSpinner = false;
        let temphold = [];
        Object.keys(data).forEach(skey => {
          this.stateSpecified = skey;
          if (skey == name) {
            Object.keys(data[skey]).forEach(dKey => {
              temphold.push(data[skey][dKey]);
              temphold.sort((a, b) => (a.name > b.name) ? 1 : -1);

            })
          }
        })
        this.dropdownlist = temphold;

      });
    }
  }
  indicatorExcelData() {
    // this.dropdownlist = [];
    let itemid: any = [];
    Object.keys(this.group).forEach(key => {
      itemid.push(this.group[key]['item_id']);
    })
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['STATE'],
      "pType": this.constants.LOCATION_CONSTANT['REGION'],
      "ay": this.selectedYear,
      "view": "admin",
      "locations": "[" + itemid.toString() + "]"

    }
    this.activeSpinner = true;
    this.submitdataSerivce.downloadIndicatorTableData(postdata).subscribe(result => {
      this.activeSpinner = false;
      if (!Array.isArray(result)) {
        let fname = "Report" + (new Date()).getTime() + ".xls"
        this.utils.downloadFile(result, fname);

      }
    })
  }
  indicatorDistrictsData() {
    let itemid = [];
    itemid.push(this.districtslu);
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType": this.constants.LOCATION_CONSTANT['STATE'],
      "ay": this.selectedYear,
      "view": "admin",
      "locations": "[" + itemid.toString() + "]"
    }
    this.activeSpinner = true;
    this.submitdataSerivce.downloadIndicatorTableData(postdata).subscribe(result => {
      this.activeSpinner = false;

      if (!Array.isArray(result)) {
        let fname = "Report" + (new Date()).getTime() + ".xls"
        this.utils.downloadFile(result, fname);

      }
    })
  }
  getsmartChartViewData() {    
    this.biharchartData = null;
    this.jkchartdata = null;
    this.UPchartdata = null;
    this.UKchartdata = null;
    this.WBchartdata = null;
    let entitylist: any = [];
    Object.keys(this.statearrayList).forEach(statelist => {
      entitylist.push(this.statearrayList[statelist]['item_id']);
    });
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType": this.constants.LOCATION_CONSTANT['STATE'],
      "ay": this.selectedYear,
      "view": "admin",
      "pList": entitylist,
      "subTp": this.monthlist['montharray']
    }
    this.submitdataSerivce.getBarChartData(postdata).subscribe(data => {
      Object.keys(data).forEach(key => {
        data[key].sort((a, b) => (a.val < b.val) ? 1 : -1);
      });
      this.smartchartdata = data;

      if (this.smartchartdata['BIHAR']) {
        this.biharchartData = {
          "title": this.lang=='en'?"Bihar Districts":chartDatas["Bihar Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [{
            name: this.lang=='en'?'Score':chartDatas['Score'],
            data: [

            ]
          }]
        }
      // }
      this.smartchartdata['BIHAR'].forEach(ele => {
        let key = ele['val'].toFixed(2);
        let tempobj = { name: (this.lang=='en'?ele['en']:districtsdata[ele['en']]), y: +key }
        this.biharchartData['seriesdata'][0]['data'].push(tempobj);
      });
      let temp = this.biharchartData['seriesdata'][0]['data'];
      this.biharstateArray = [];
      Object.keys(temp).forEach((key) => {
        this.biharstateArray.push(temp[key]['name']);
      });      
    }
      if (this.smartchartdata['JHARKHAND']) {
        this.jkchartdata = {
          "title": this.lang=='en'?"Jharkhand Districts":chartDatas["Jharkhand Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [{
            name: this.lang=='en'?'Score':chartDatas['Score'],
            data: [

            ]
          }]
        }
      // }
      this.smartchartdata['JHARKHAND'].forEach(ele => {
        let key = ele['val'].toFixed(2);
        let tempobj = { name: (this.lang=='en'?ele['en']:districtsdata[ele['en']]), y: +key }
        this.jkchartdata['seriesdata'][0]['data'].push(tempobj);
      });
      let temp2 = this.jkchartdata['seriesdata'][0]['data'];
      this.jharkandstateArray = [];
      Object.keys(temp2).forEach((key) => {
        this.jharkandstateArray.push(temp2[key]['name']);
      });
    }
      if (this.smartchartdata['UTTAR PRADESH']) {
        this.UPchartdata = {
          "title": this.lang=='en'?"Uttar Pradesh Districts":chartDatas["Uttar Pradesh Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [{
            name: this.lang=='en'?'Score':chartDatas['Score'],
            data: [

            ]
          }]
        }
      // }
      this.smartchartdata['UTTAR PRADESH'].forEach(ele => {
        let key = ele['val'].toFixed(2);
        let tempobj = { name: (this.lang=='en'?ele['en']:districtsdata[ele['en']]), y: +key }
        this.UPchartdata['seriesdata'][0]['data'].push(tempobj);
      });
      let temp3 = this.UPchartdata['seriesdata'][0]['data'];
      this.UPstateArray = [];
      Object.keys(temp3).forEach((key) => {
        this.UPstateArray.push(temp3[key]['name']);
      });
    }
      if (this.smartchartdata['UTTARAKHAND']) {
        this.UKchartdata = {
          "title": this.lang=='en'?"Uttarakhand Districts":chartDatas["Uttarakhand Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [{
            name: this.lang=='en'?'Score':chartDatas['Score'],
            data: [

            ]
          }]
        }
      // }
      this.smartchartdata['UTTARAKHAND'].forEach(ele => {
        let key = ele['val'].toFixed(2);
        let tempobj = { name: (this.lang=='en'?ele['en']:districtsdata[ele['en']]), y: +key }
        this.UKchartdata['seriesdata'][0]['data'].push(tempobj);
      });
      let temp4 = this.UKchartdata['seriesdata'][0]['data'];
      this.UKstateArray = [];
      Object.keys(temp4).forEach((key) => {
        this.UKstateArray.push(temp4[key]['name']);
      });
    }
      if (this.smartchartdata['WEST BENGAL']) {
        this.WBchartdata = {
          "title": this.lang=='en'?"West Bengal Districts":chartDatas["West Bengal Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [{
            name: this.lang=='en'?'Score':chartDatas['Score'],
            data: [

            ]
          }]
        }
      // }
      this.smartchartdata['WEST BENGAL'].forEach(ele => {
        let key = ele['val'].toFixed(2);
        let tempobj = { name: (this.lang=='en'?ele['en']:districtsdata[ele['en']]), y: +key }
        this.WBchartdata['seriesdata'][0]['data'].push(tempobj);
      });
      let temp5 = this.WBchartdata['seriesdata'][0]['data'];
      this.WBstateArray = [];
      Object.keys(temp5).forEach((key) => {
        this.WBstateArray.push(temp5[key]['name']);
      });
    }
    })
  }
  getDataForBarChart() {
    this.nonhimalayanchartdata = null;
    this.himalayanchartdata = null;
    let itemid: any = [];
    Object.keys(this.group).forEach(key => {
      itemid.push(this.group[key]['item_id'])
    })
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['STATE'],
      "pType": this.constants.LOCATION_CONSTANT['REGION'],
      "ay": this.selectedYear,
      "view": "admin",
      "pList": itemid
    }
    postdata['cType'] = this.statelevel == 'statewise' ? 'DISTRICT' : postdata['cType'];
    postdata['pType'] = this.statelevel == 'statewise' ? 'STATE' : postdata['pType'];

    this.submitdataSerivce.getBarChartData(postdata).subscribe(data => {
      this.currentGroupState = [];

      // sorting
      Object.keys(data).forEach(key => {
        data[key].sort((a, b) => (a.val < b.val) ? 1 : -1);
      })


      this.chartData = data;      
      let temparray = Object.keys(data);
      this.currentGroupState = Object.keys(data);
      if (this.chartData[temparray[0]]) {
        this.nonhimalayanchartdata = {
          "title": this.currentGroupState[0],
          "seriesdata": [{
            name: 'Score',
            data: [

            ]
          }]
        }

        this.chartData[temparray[0]].forEach(ele => {
          let x = ele['val'].toFixed(2);
          let obj = { name: ele['en'], y: +x }
          if (this.nonhimalayanchartdata['seriesdata'][0])
            this.nonhimalayanchartdata['seriesdata'][0]['data'].push(obj);
        })

        let temp = this.nonhimalayanchartdata['seriesdata'][0]['data'];
        this.nonhimalayanstateArray = [];
        Object.keys(temp).forEach((key) => {
          this.nonhimalayanstateArray.push(temp[key]['name']);
        });
      }
    }, function (error) {
    });
  }
  getlocationcomparisionData() {   
    let locationlist: any = [];
    if (!isNullOrUndefined(this.statearrayList)) {
      Object.keys(this.statearrayList).forEach(statelist => {
        locationlist.push(this.statearrayList[statelist]['item_id']);
      });
    }
    let postdata = {
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType": this.constants.LOCATION_CONSTANT['STATE'],
      "ay": this.selectedYear,
      "view": "admin",
      "lu": locationlist,
      "subTp": this.monthlist['montharray']
    }
    this.submitdataSerivce.getBarBubbleChartData(postdata).subscribe(data => {
      Object.keys(data).forEach(key => {
        data[key].sort((a, b) => (a.rank > b.rank) ? 1 : -1);
      });
      this.locationData = data;
      if (this.locationData['BIHAR']) {
        this.showchart = false;
        this.locationBiharData = {
          "title": this.lang=='en'?"Bihar Districts":chartDatas["Bihar Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [
            {
              type: "bar",
              name: this.lang=='en' ? 'Change in Score' : chartDatas['change in score'],
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "Base year(FY" + this.prevyear + ") score" : "आधार वर्ष(वित्तीय वर्ष" + this.prevyear + ") अंक" ,
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "FY" + this.curyear + " score" :"वित्तीय वर्ष" + this.curyear + " अंक",
              data: [

              ]
            }
          ]
        }

        this.locationData['BIHAR'].forEach(ele => {
          let x = ele['diff'].toFixed(2);
          let obj = { name: ele['name'], y: +x }
          let obj1 = { name: ele['name'], y: ele['baseValue'] }
          let obj2 = { name: ele['name'], y: ele['currentValue'] }
          this.locationBiharData['seriesdata'][0]['data'].push(obj);
          this.locationBiharData['seriesdata'][1]['data'].push(obj1);
          this.locationBiharData['seriesdata'][2]['data'].push(obj2);

        })

        let temp = this.locationBiharData['seriesdata'][0]['data'];
        this.locationBiharStateArray = [];
        Object.keys(temp).forEach((key) => {
          let distname=this.lang=='en' ? temp[key]['name'] : districtsdata[temp[key]['name']];
          this.locationBiharStateArray.push(distname);
        });
      }
      else {

        this.showchart = true;
      }
      if (this.locationData['JHARKHAND']) {
        this.showchart = false;
        this.locationJKData = {
          "title": this.lang=='en'?"Jharkhand Districts":chartDatas["Jharkhand Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [
            {
              type: "bar",
              name: this.lang=='en' ? 'Change in Score' : chartDatas['change in score'],
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name:  this.lang=='en' ? "Base year(FY" + this.prevyear + ") score" : "आधार वर्ष(वित्तीय वर्ष" + this.prevyear + ") अंक" ,
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "FY" + this.curyear + " score" :"वित्तीय वर्ष" + this.curyear + " अंक",
              data: [

              ]
            }
          ]
        }

        this.locationData['JHARKHAND'].forEach(ele => {
          let x = ele['diff'].toFixed(2);
          let obj = { name: ele['name'], y: +x }
          let obj1 = { name: ele['name'], y: ele['baseValue'] }
          let obj2 = { name: ele['name'], y: ele['currentValue'] }
          this.locationJKData['seriesdata'][0]['data'].push(obj);
          this.locationJKData['seriesdata'][1]['data'].push(obj1);
          this.locationJKData['seriesdata'][2]['data'].push(obj2);

        })

        let temp = this.locationJKData['seriesdata'][0]['data'];
        this.locationJKStateArray = [];
        Object.keys(temp).forEach((key) => {
          this.locationJKStateArray.push(temp[key]['name']);
        });
      }
      else {

        this.showchart = true;
      }

      //  union territories

      if (this.locationData['UTTAR PRADESH']) {
        this.showchart = false;
        this.locationUPData = {
          "title": this.lang=='en'?"Uttar Pradesh Districts":chartDatas["Uttar Pradesh Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [
            {
              type: "bar",
              name: this.lang=='en' ? 'Change in Score' : chartDatas['change in score'],
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name:  this.lang=='en' ? "Base year(FY" + this.prevyear + ") score" : "आधार वर्ष(वित्तीय वर्ष" + this.prevyear + ") अंक" ,
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "FY" + this.curyear + " score" :"वित्तीय वर्ष" + this.curyear + " अंक",
              data: [

              ]
            }
          ]
        }

        this.locationData['UTTAR PRADESH'].forEach(ele => {
          let x = ele['diff'].toFixed(2);
          let obj = { name: ele['name'], y: +x }
          let obj1 = { name: ele['name'], y: ele['baseValue'] }
          let obj2 = { name: ele['name'], y: ele['currentValue'] }
          this.locationUPData['seriesdata'][0]['data'].push(obj);
          this.locationUPData['seriesdata'][1]['data'].push(obj1);
          this.locationUPData['seriesdata'][2]['data'].push(obj2);

        })

        let temp = this.locationUPData['seriesdata'][0]['data'];
        this.locationUPStateArray = [];
        Object.keys(temp).forEach((key) => {
          let distname=this.lang=='en' ? temp[key]['name'] : districtsdata[temp[key]['name']];
          this.locationUPStateArray.push(distname);
        });
      }
      else {

        this.showchart = true;
      }
      if (this.locationData['UTTARAKHAND']) {
        this.showchart = false;
        this.locationUKData = {
          "title": this.lang=='en'?"Uttarakhand Districts":chartDatas["Uttarakhand Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [
            {
              type: "bar",
              name: this.lang=='en' ? 'Change in Score' : chartDatas['change in score'],
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name:  this.lang=='en' ? "Base year(FY" + this.prevyear + ") score" : "आधार वर्ष(वित्तीय वर्ष" + this.prevyear + ") अंक" ,
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "FY" + this.curyear + " score" :"वित्तीय वर्ष" + this.curyear + " अंक",
              data: [

              ]
            }
          ]
        }

        this.locationData['UTTARAKHAND'].forEach(ele => {
          let x = ele['diff'].toFixed(2);
          let obj = { name: ele['name'], y: +x }
          let obj1 = { name: ele['name'], y: ele['baseValue'] }
          let obj2 = { name: ele['name'], y: ele['currentValue'] }
          this.locationUKData['seriesdata'][0]['data'].push(obj);
          this.locationUKData['seriesdata'][1]['data'].push(obj1);
          this.locationUKData['seriesdata'][2]['data'].push(obj2);

        })

        let temp = this.locationUKData['seriesdata'][0]['data'];
        this.locationUKStateArray = [];
        Object.keys(temp).forEach((key) => {
          let distname=this.lang=='en' ? temp[key]['name'] : districtsdata[temp[key]['name']];
          this.locationUKStateArray.push(distname);
        });
      }
      else {

        this.showchart = true;
      }

      //  union territories

      if (this.locationData['WEST BENGAL']) {
        this.showchart = false;
        this.locationWBData = {
          "title": this.lang=='en'?"West Bengal Districts":chartDatas["West Bengal Districts"],
          "baseyear": this.prevyear,
          "curyear": this.curyear,
          "seriesdata": [
            {
              type: "bar",
              name: this.lang=='en' ? 'Change in Score' : chartDatas['change in score'],
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "Base year(FY" + this.prevyear + ") score" : "आधार वर्ष(वित्तीय वर्ष" + this.prevyear + ") अंक" ,
              data: [

              ]
            },
            {
              yAxis: 1,
              type: "scatter",
              name: this.lang=='en' ? "FY" + this.curyear + " score" :"वित्तीय वर्ष" + this.curyear + " अंक",
              data: [

              ]
            }
          ]
        }

        this.locationData['WEST BENGAL'].forEach(ele => {
          let x = ele['diff'].toFixed(2);
          let obj = { name: ele['name'], y: +x }
          let obj1 = { name: ele['name'], y: ele['baseValue'] }
          let obj2 = { name: ele['name'], y: ele['currentValue'] }
          this.locationWBData['seriesdata'][0]['data'].push(obj);
          this.locationWBData['seriesdata'][1]['data'].push(obj1);
          this.locationWBData['seriesdata'][2]['data'].push(obj2);

        })

        let temp = this.locationWBData['seriesdata'][0]['data'];
        this.locationWBStateArray = [];
        Object.keys(temp).forEach((key) => {
          let distname=this.lang=='en' ? temp[key]['name'] : districtsdata[temp[key]['name']];
          this.locationWBStateArray.push(distname);
        });
      }
      else {

        this.showchart = true;
      }
    })
  }

  // getDataForBarBubbleChart() {
  //   let itemid: any=[];
  //   Object.keys(this.group).forEach(key =>{
  //     itemid.push(this.group[key]['item_id'])
  //   })
  //   let postdata = {
  //     "cType" : this.constants.LOCATION_CONSTANT['STATE'],
  //     "pType" : this.constants.LOCATION_CONSTANT['REGION'],
  //     "ay": this.selectedYear,
  //     "view" : "admin",
  //     "lu" : itemid
  //   }
  //   postdata['cType'] = this.statelevel == 'statewise' ? 'DISTRICT': postdata['cType'];
  //   postdata['pType'] = this.statelevel == 'statewise' ? 'STATE' : postdata['pType'];

  //   this.submitdataSerivce.getBarBubbleChartData(postdata).subscribe(data => {



  //     // sorting 

  //     Object.keys(data).forEach(key => {
  //       data[key].sort((a, b) => (a.rank > b.rank) ? 1 : -1);
  //     })

  //     this.chartData = data;

  //     if(this.chartData['NORTH EASTERN AND HIMALAYAN'])
  //     {
  //       this.showchart=false;
  //       this.noneasternFYchartdata = {
  //         "title" : "North Eastern and Himalayan states",
  //         "baseyear" : this.prevyear,
  //         "curyear" : this.curyear,
  //         "seriesdata" : [
  //           {
  //             type: "bar",
  //             name: 'Change in Score',
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "Base year(FY" + this.prevyear + ") score",
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "FY" + this.curyear + " score",
  //             data : [

  //             ]
  //           }
  //         ]
  //       }

  //       this.chartData['NORTH EASTERN AND HIMALAYAN'].forEach(ele => {
  //         let x = ele['diff'].toFixed(2);
  //         let obj = {name: ele['name'], y: +x}
  //         let obj1 = {name: ele['name'], y: ele['baseValue']}
  //         let obj2 = {name: ele['name'], y: ele['currentValue']}
  //         this.noneasternFYchartdata['seriesdata'][0]['data'].push(obj);
  //         this.noneasternFYchartdata['seriesdata'][1]['data'].push(obj1);
  //         this.noneasternFYchartdata['seriesdata'][2]['data'].push(obj2);

  //       })

  //       let temp=this.noneasternFYchartdata['seriesdata'][0]['data'];
  //       this.noneasternFYstateArray = [];
  //       Object.keys(temp).forEach((key)=>{
  //           this.noneasternFYstateArray.push(temp[key]['name']);
  //       });
  //     }
  //     else{

  //       this.showchart=true;
  //     }

  //     ///   non himalayan


  //     if(this.chartData['NON HIMALAYAN'])
  //     {
  //       this.showchart=false;
  //       this.nonhimalayanFYchartdata = {
  //         "title" : "Non Himalayan States",
  //         "baseyear" : this.prevyear,
  //         "curyear" : this.curyear,
  //         "seriesdata" : [
  //           {
  //             type: "bar",
  //             name: 'Change in Score',
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "Base year(FY" + this.prevyear + ") score",
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "FY" + this.curyear + " score",
  //             data : [

  //             ]
  //           }
  //         ]
  //       }

  //       this.chartData['NON HIMALAYAN'].forEach(ele => {
  //         let x = ele['diff'].toFixed(2);
  //         let obj = {name: ele['name'], y: +x}
  //         let obj1 = {name: ele['name'], y: ele['baseValue']}
  //         let obj2 = {name: ele['name'], y: ele['currentValue']}
  //         this.nonhimalayanFYchartdata['seriesdata'][0]['data'].push(obj);
  //         this.nonhimalayanFYchartdata['seriesdata'][1]['data'].push(obj1);
  //         this.nonhimalayanFYchartdata['seriesdata'][2]['data'].push(obj2);

  //       })

  //       let temp=this.nonhimalayanFYchartdata['seriesdata'][0]['data'];
  //       this.nonhimalayanFYstateArray = [];
  //       Object.keys(temp).forEach((key)=>{
  //           this.nonhimalayanFYstateArray.push(temp[key]['name']);
  //       });
  //     }
  //     else{

  //       this.showchart=true;
  //     }

  //     //  union territories

  //     if(this.chartData['UNION TERRITORIES'])
  //     {
  //    this.showchart=false;
  //       this.unionFYchartdata = {
  //         "title" : "Union Territories",
  //         "baseyear" : this.prevyear,
  //         "curyear" : this.curyear,
  //         "seriesdata" : [
  //           {
  //             type: "bar",
  //             name: 'Change in Score',
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "Base year(FY" + this.prevyear + ") score",
  //             data : [

  //             ]
  //           },
  //           {
  //             yAxis: 1,
  //             type: "scatter",
  //             name: "FY" + this.curyear + " score",
  //             data : [

  //             ]
  //           }
  //         ]
  //       }

  //       this.chartData['UNION TERRITORIES'].forEach(ele => {
  //         let x = ele['diff'].toFixed(2);
  //         let obj = {name: ele['name'], y: +x}
  //         let obj1 = {name: ele['name'], y: ele['baseValue']}
  //         let obj2 = {name: ele['name'], y: ele['currentValue']}
  //         this.unionFYchartdata['seriesdata'][0]['data'].push(obj);
  //         this.unionFYchartdata['seriesdata'][1]['data'].push(obj1);
  //         this.unionFYchartdata['seriesdata'][2]['data'].push(obj2);

  //       })

  //       let temp=this.unionFYchartdata['seriesdata'][0]['data'];
  //       this.unionFYstateArray = [];
  //       Object.keys(temp).forEach((key)=>{
  //           this.unionFYstateArray.push(temp[key]['name']);
  //       });
  //     }
  //     else{

  //       this.showchart=true;
  //     }


  //   })
  // }
  validateTableObject(value) {
    if (value == null || value == undefined || value == '') {
      return '-'
    } else {
      return Number(value.toFixed(2)).toLocaleString('en-IN');
    }
  }
  getComparisonTableData() {


    this.showtabledata = true;

    let postdata = {
      "cType": this.statelevel == 'statewise' ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE'],
      "pType": this.statelevel == 'statewise' ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['REGION'],
      "ay": this.selectedYear,
      "view": "admin",
      "lu": this.statelevel == 'statewise' ? this.urlparams['grouparray'] : this.group,
      "isFileDownload": false
    }
    this.submitdataSerivce.getComparisonReportTableData(postdata).subscribe(data => {

      data.sort((a, b) => (a.currentRank > b.currentRank) ? 1 : -1);
      this.tabledata = data;
      if (this.tabledata.length > 0)
        this.showtabledata = true;

    })
  }
  getCustomTableData() {
    this.showcustomtable = true;
    this.customTableData = [];
    let lu = [];
    let indicator = [];
    this.statelist = [];
    this.rankactual = [];
    let i = 0;
    
    this.activeSpinner = true;
    if (this.urlparams['statearray'].length > 0) {
      this.statelist = this.urlparams['statearray'];
      //this.statelist=this.filterOptions['statearray'];
      this.urlparams['statearray'].forEach(key => {
        lu.push(key['uuid']);
        this.rankactual.push("Rank");
        this.rankactual.push("ActualValue")
      });
      if(this.urlparams['indicatorarray'].length > 0){
      this.urlparams['indicatorarray'].forEach(ind => {
        indicator.push(ind['item_id']);
      });
      }
      let postdata = {
        "lu": JSON.stringify(lu),
        "indicator": JSON.stringify(indicator),
        "ay": this.urlparams['assesmentyear'],
        "view": "admin",
        "subTp": this.monthlist['montharray'],
        "component": this.constants.COMPONENT["ACTUAL_DATA"],
        "approval_level": 1,
        "verific_status": 1,
        "cType": this.constants.LOCATION_CONSTANT['DISTRICT']
      }
      this.submitdataSerivce.getCustomRankingData(postdata).subscribe(customdata => {
        if (Object.keys(customdata['data']).length > 0) {
          this.showcustomtable = true;
          this.fetchindicatorData(customdata['data']);
        } else {
          this.showcustomtable = false;
        }

        this.activeSpinner = false;
      });
    }
  }
  fetchindicatorData(customdata) {
    let options = {
      "ay": this.urlparams['assesmentyear']
    }
    this.submitdataSerivce.FetchIndicators(options).subscribe(data => {
      data.forEach(theme => {
        theme['childList'].forEach(indlist => {

          let obj = {};
          let labeldata = {};
          if (customdata[indlist['entityUUID']] && indlist['year'] == this.urlparams['assesmentyear']) {
            labeldata = indlist;
            obj['sno'] = labeldata['sno'];
            obj['label'] = labeldata['label'];
            this.statelist.forEach(state => {
              obj[state.uuid + 'rank'] = null;
              obj[state.uuid + '_actualData'] = null;
              customdata[indlist['entityUUID']].forEach(list => {
                if (state['uuid'] == list.entityUUID) {
                  obj[list.entityUUID + 'rank'] = list['rank'];
                  obj[list.entityUUID + '_actualData'] = list['actualData'];
                }
              });
            });
            if (Object.keys(obj).length > 0) {
              this.customTableData.push(obj);

            }

          }
        });
      });
    });
  }
  getIndicatorLabel(id, data) {
    let labeldata = {};
    data.forEach(theme => {
      theme['childList'].forEach(indlist => {
        if (indlist['entityUUID'] == id) {
          labeldata['label'] = indlist['label'];
          labeldata['sno'] = indlist['sno'];
        }
      });
    });
    return labeldata;
  }
  checkvalue(val, type) {
    if (val && type) {
      if (type.split('_')[1] == 'actualData')
        return val == 'YES' ? 'YES' : (val == 'NO' ? 'NO' : parseFloat(val).toFixed(2));
      return val;
    }
    else if (val)
      return val;
    return '-';
  }
  checkcoulmnforcolor(val, type) {
    if (type) {
      if (type.split('_')[1] == 'actualData') {
        return val == 'YES' ? false : (val == 'NO' ? false : true)
      }
    }
    return false;
  }
  getcolor(val) {
    if (val) {
      if (val >= 0 && val <= 50) {
        return '#eaedf0'
      } else {
        return '#ffe9cc'
      }
    }
    return;
  }
  getcustomlabel(sno) {
    return this.customlabels[sno];
  }

  public navtabclick(type) {
    this.monthlist={ 'montharray': '' }
    //('month kist value',this.monthlist);
    // this.monthlist['montharray']= '';
    // this.monthlist = null;
    if (type == this.activesidetab)
      return
    this.activesidetab = type;
    // if (this.activesidetab == 'comparison')
    //   this.ngOnInit();
  
      
  }

  emptyMonth(){    
    this.monthlist = null;    
  }

  addMap() {
    let randomid = Math.floor(Math.random() * 6) + 1;
    this.indicatormap = "map" + randomid;
    this.map = L.map('indicatormap', {
      minZoom: 4,
      maxZoom: 12,
      zoomControl: false,
      zoomDelta: 0.5,
      zoomSnap: 0.1
    });
    this.map.setView([23.87155, 76.01109], 4.7);
    this.map.scrollWheelZoom.disable();
    this.addZoomBar();
  }
  addZoomBar(): void {
    let zoomBarControl = new (L as any).control.zoomBar();
    zoomBarControl.addTo(this.map)
  }
  createPanes() {
    this.mapConstantsModule.PANE_LIST.forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }
  async createLayer(data) {
    let options = this.getWritableObject(this.route.snapshot.params);
    this.statelayer = this.gisService.addVectorLayer(this.mapConstantsModule.GROUP_LIST[2]['layersList'][1], options, this.map, this.activeLayers, this.activeFeatureData, false,this.userdetails);
    this.fillMapByStatesPerform(true, data);
    this.map.addLayer(this.gisService.addWMSLayer(this.mapConstantsModule.GROUP_LIST[1]['layersList'][1]))
  }
  fillMapByStatesPerform(init: boolean, data) {
    var that = this;
    let fillBoundaries: any = {};
    fillBoundaries = {
      fill: true,
      fillOpacity: 1,
      opacity: 1,
      weight: 2,
      color: "#000000"
    };
    let statelayer = this.statelayer['STATES_PERFORMING'];
    if (!isNullOrUndefined(statelayer)) {
      statelayer.options.vectorTileLayerStyles['final_data_cwmi'] = function (properties: object, zoom) {
        fillBoundaries.fillColor = that.getRankColor(properties, data);
        return fillBoundaries;
      }
    }
    if (this.map.hasLayer(statelayer)) {
      this.map.removeLayer(statelayer);
      this.map.addLayer(statelayer);
    }
    if (init)
      this.gisService.addLegendToModal('STATES_YES_NO', statelayer, this.htmlLegend);
  }
  getRankColor(properties: object, data) {
    var colorcode = "#e9ebee";
    data.forEach(list => {
      if (properties['uuid'] == list['uuid']) {
        colorcode = this.getcolorcode(list['currentValue']);
        return colorcode;
      }
    });
    return colorcode;
  }
  getcolorcode(flag) {
    if (flag == 'YES') {
      return "#8ee87c";
    } else if (flag == 'NO') {
      return "#f56161";
    } else {
      return "#e9ebee";
    }
  }
  exportToExcel(): void {
    let fileName = 'CustomRankingdata.xlsx';
    let element = document.getElementById('customId');
    let addOn = Object.keys(this.customTableData[0]).length + 1;
    let tableLength = this.customTableData.length;
    let index = 1, i = 0;
    let prevIndex = [];
    while (tableLength--) {
      let spanx = element.getElementsByTagName('span')[index];
      let prevTextContent = spanx.textContent
      prevIndex.push(prevTextContent);
      spanx.textContent = this.customTableData[i]['label'];
      if (i > 0) {
        spanx.textContent = spanx.textContent.substring(4);
      }
      i++;
      index += addOn;
    }
    tableLength = this.customTableData.length;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName);
    index = 1, i = 0;
    while (tableLength--) {
      let spanx = element.getElementsByTagName('span')[index];
      spanx.textContent = prevIndex[i];
      i++;
      index += addOn;
    }
  }

  public downloadExcel() {
    let postdata = {};
    postdata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata['ay'] = this.selectedYear;
    postdata['subTp'] = this.monthlist['montharray'];
    postdata['view'] = "admin";
    postdata['isFileDownload'] = true;
    postdata['lu'] = this.filterstates;
    postdata['locuuid'] = this.filterdist;
    postdata['comparedlu'] = this.basestateId;
    postdata['comparedlocuuid'] = this.basedistrictId;
    // postdata = {
    //   "cType": this.statelevel == 'statewise' ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE'],
    //   "pType": this.statelevel == 'statewise' ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['REGION'],
    //   "ay": this.selectedYear,
    //   "view": "admin",
    //   // "lu" : this.group,
    //   "isFileDownload": true
    // }

    // if (this.statelevel == 'statewise') {
    //   postdata['lu'] = this.urlparams['grouparray']
    // } else {
    //   postdata['lu'] = this.group;
    // }

    this.submitdataSerivce.downloadComparisonTableData(postdata).subscribe(result => {

      if (!Array.isArray(result)) {

        let fname = "Report" + (new Date()).getTime() + ".xls"
        this.utils.downloadFile(result, fname);

      }
    })
  }

  getWritableObject(obj: object): object {
    if (obj == null || obj == undefined) return obj;

    let objectConfig = {};
    for (let key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }
  trimvalue(num) {
    num = num.toString(); //If it's not already a String
    num = num.slice(0, (num.indexOf(".")) + 3); //With 2 exposing the hundredths place
    return num;
  }
  makevaluespositive(value) {
    return Math.abs(value);
  }
  geturlparamsindData(indiuuid) {
    let data = {};
    this.urlparams['indicatorlist'].forEach(subobj => {
      subobj['childList'].forEach(id => {
        if (indiuuid == id['entityUUID']) {
          data = id;
        }
      });
    });
    return data;
  }
  makeValuepositive(row) {
    return Math.abs(row);
  }
  getindicatorwiseCompare() {
    this.showindchartdata = false;
    this.showthemechartdata = false;
    //let locationlist: any = [];
    // Object.keys(this.statearrayList).forEach(statelist => {
    //   locationlist.push(this.statearrayList[statelist]['item_id']);
    // });
    let senddata = {
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType": this.constants.LOCATION_CONSTANT['STATE'],
      "ay": this.selectedYear,
      "view": "admin",
      "subTp": this.monthlist['montharray'],
      "type": this.type,
      "uuid": this.uuid,
      "pu": this.filterstates,//this.basestateId //this.filterdist
      "lu":this.filterdist
    }
    this.submitdataSerivce.getBubbleChartData(senddata).subscribe(data => {
      this.bubblechartdata = data;
      if (this.type == 'INDICATOR') {
        let indobj = this.geturlparamsindData(this.uuid);
        this.showindicatordata = true;
        // if (indobj['ip'] != 'BOOLEAN') {
          if (indobj['ip']) {
          this.showmap = false;
          this.indicatorArray = [];
          data.sort((a, b) => (a.currentValue < b.currentValue) ? 1 : -1);

          this.chartData = data;

          if (this.chartData) {
            this.indicatordata = {
              "title": "Indicator Data",
              // "baseyear" : this.prevyear,
              "curyear": this.curyear,
              "seriesdata": [
                {
                  name: 'FY ' + this.curyear,
                  data: [

                  ]
                },

              ]
            }

            // indobj['sno'] != '8' && indobj['sno'] != '23(b)' ? this.indicatordata['seriesdata'][1] = {
            //   name: 'Base year (FY ' + this.prevyear + ')',
            //   data: [

            //   ]
            // } : null
            // console.log('chart data',this.chartData);
            if (senddata['pu']=="10834cae-7a77-4ccc-8a15-0f354f98c52a"){
              Object.values(this.chartData).forEach(ele => {
                if (ele['name'] == "Bokaro" || ele['name']=='Dhanbad' || ele['name'] == 'Ramgarh' || ele['name']=="Sahibganj"){
                  let x, z, obj, obj1
                  x = ele['baseValue'] ? ele['baseValue'].toFixed(2) : null;
                  obj = { name: ele['name'], y: +x }
                  z = ele['currentValue'] ? ele['currentValue'].toFixed(2) : null;
                  obj1 = { name: ele['name'], y: +z }
                  this.indicatordata['seriesdata'][0]['data'].push(obj1);
                  // indobj['sno'] != '8' && indobj['sno'] != '23(b)' ? this.indicatordata['seriesdata'][1]['data'].push(obj) : '';
                }
              })
  

            }
            else{
              Object.values(this.chartData).forEach(ele => {
                let x, z, obj, obj1
                x = ele['baseValue'] ? ele['baseValue'].toFixed(2) : null;
                obj = { name: ele['name'], y: +x }
                z = ele['currentValue'] ? ele['currentValue'].toFixed(2) : null;
                obj1 = { name: ele['name'], y: +z }
                this.indicatordata['seriesdata'][0]['data'].push(obj1);
                // indobj['sno'] != '8' && indobj['sno'] != '23(b)' ? this.indicatordata['seriesdata'][1]['data'].push(obj) : '';
              })
            }

            let temp = this.indicatordata['seriesdata'][0]['data'];

            Object.keys(temp).forEach((key) => {
              this.indicatorArray.push(temp[key]['name']);
            });
          }
        } else {
          this.showmap = true;
          setTimeout(() => {
            this.initializeMap(data);
          }, 1000)
        }


      }
      else {
        this.themearray = [];
        this.themedata = {};
        if (data.length > 0) {

          this.showthemedata = true;
          this.themedata = {
            "title": "Theme Data",
            "baseyear": this.prevyear,
            "curyear": this.curyear,
            "median": data[data.length - 1]['median'],
            "seriesdata": [
              {
                name: "Base year(FY " + this.prevyear + ") score",
                data: [

                ]
              },
              {
                name: "FY " + this.curyear + " score",
                data: [

                ]
              }
            ]
          }

          let i = 0;
          data.forEach(ele => {
            if (i < (data.length - 1)) {
              let x, z, obj, obj1;
              if (ele['baseValue']) {
                x = ele['baseValue'].toFixed(2);
                obj = { name: ele['name'], y: +x }
              } else {
                obj = { name: ele['name'], y: ele['baseValue'] }
              }
              this.themedata['seriesdata'][0]['data'].push(obj);

              if (ele['currentValue']) {
                z = ele['currentValue'].toFixed(2);
                obj1 = { name: ele['name'], y: +z }
              } else {
                obj1 = { name: ele['name'], y: ele['currentValue'] }
              }
              this.themedata['seriesdata'][1]['data'].push(obj1);
              i++;
            }

          })

          let temp = this.themedata['seriesdata'][0]['data'];

          Object.keys(temp).forEach((key) => {
            this.themearray.push(temp[key]['name']);
          });
        }
      }


      this.activeSpinner = false;
    }, function (error) {
      // this.activeSpinner = false;
    });
  }
  getTableDataforComparisonView() {
    let senddata = {};
    senddata = this.formatSendData();
    this.submitdataSerivce.getComparisonReportTableData(senddata).subscribe(formatdata => {
      formatdata.sort((a, b) => (a.currentRank > b.currentRank) ? 1 : -1);
      this.getcomapriondata = formatdata;
      if (this.getcomapriondata.length > 0) {
        Object.keys(formatdata).forEach(report => {
          this.getcomapriondata.push(report);
        })
      }
    })
  }
  formatSendData() {
    let senddata = {};
    senddata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'];
    senddata['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
    senddata['ay'] = this.selectedYear;
    senddata['view'] = "admin";
    senddata['subTp'] = this.monthlist['montharray'];
    senddata['lu'] = this.filterstates;
    senddata['isFileDownload'] = false;
    return senddata;
  }
  gettabledata() {
    let postdata = {};
    postdata = this.comparisonpostdata();
    this.submitdataSerivce.getComparisonReportTableData(postdata).subscribe(formatdata => {
      formatdata.sort((a, b) => (a.currentRank > b.currentRank) ? 1 : -1);
      this.tabledataobject = formatdata;
      if (this.getcomapriondata.length > 0) {
        Object.keys(formatdata).forEach(report => {
          this.tabledataobject.push(report);
        })
      }
    })
  }

  downloadPdf(pdfName) {
    let pdfUrl;
    if (pdfName == 'Round 1 report') {
      pdfUrl = './assets/report/2018-05-18-CWMI-1.0.pdf';
    } else {
      pdfUrl = './assets/report/20190822-CWMI-2.0.pdf'
    }
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  comparisonpostdata() {   
    let postdata = {};
    postdata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata['ay'] = this.selectedYear;
    postdata['subTp'] = this.monthlist['montharray'];
    postdata['view'] = "admin";
    postdata['isFileDownload'] = false;
    postdata['lu'] = this.filterstates;
    postdata['locuuid'] = this.filterdist;
    postdata['comparedlu'] = this.basestateId;
    postdata['comparedlocuuid'] = this.basedistrictId;
    return postdata;
  }
  isenglish(item){
    if (item){
      return true;
    }
    else{
      return false;
    }
  }

}
